// extracted by mini-css-extract-plugin
export default {"infoPaper":"style_infoPaper__oREYE","contentWrapper":"style_contentWrapper__ISdPK","backgroundWrapper":"style_backgroundWrapper__tzVll"};